import { render, staticRenderFns } from "./gj-compare-bar.vue?vue&type=template&id=324613ee&scoped=true&"
import script from "./gj-compare-bar.vue?vue&type=script&lang=js&"
export * from "./gj-compare-bar.vue?vue&type=script&lang=js&"
import style0 from "./gj-compare-bar.vue?vue&type=style&index=0&id=324613ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324613ee",
  null
  
)

export default component.exports